/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareAssetDetails } from './shareAssetDetails';


export interface CreateSharingAssetDto { 
    _id?: string;
    expiryDate: string;
    /**
     * List of emails to share with, can be an empty array
     */
    userEmails: Array<string>;
    description?: string;
    noDownload?: boolean;
    publicLink?: boolean;
    assetDetails: Array<ShareAssetDetails>;
}

